import React from "react";

const CalendarGrid = ({ days, selectedDays, isDayDisabled, controller, onMouseDown, onMouseEnter, onMouseUp }) => {
    return (
        <div
            className="grant-schedule__calendar-grid"
            onMouseLeave={onMouseUp}
            onMouseUp={onMouseUp}
        >
            {days.map(day => {
                const isSelected = selectedDays.includes(day);
                const isDisabled = isDayDisabled(day);

                return (
                    <div
                        key={day}
                        className={`grant-schedule__calendar-grid--day
                            ${isSelected ? "selected" : ""}
                            ${isDisabled ? "disabled" : ""}
                        `}
                        onMouseDown={() => !isDisabled && onMouseDown(day)}
                        onMouseEnter={() =>
                            !isDisabled &&
                            controller.getIsDragging() &&
                            onMouseEnter(day)
                        }
                    >
                        {day}
                    </div>
                );
            })}
        </div>
    );
};

export default CalendarGrid;